import React, {useLayoutEffect, useRef, useState} from 'react';
import classnames from "classnames";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import threeDots from "../../../modules/InspectedList/assets/three-dots.svg";
import styles from "./styles.module.scss";

const Menu = ({
                isOpen,
                itemProps,
                content,
                customMenuStyles,
                customMenuFallsStyles
              }) => {
  const [menuFalls, setMenuFalls] = useState(false);
  const menuRef = useRef(null);

  useLayoutEffect(() => {
    if (checkMenuFallsFromViewport()) {
      setMenuFalls(true);
    } else {
      setMenuFalls(false);
    }
  }, [isOpen]);

  const checkMenuFallsFromViewport = () => {
    if (isOpen && Boolean(menuRef.current)) {
      const {bottom} = menuRef.current.getBoundingClientRect();
      return bottom > window.innerHeight;
    }
    return false;
  };

  const mapContent = (item, index) => {
    if (item) {
      return (
        <div
          className={styles.menuItem}
          {...itemProps[index]}
          role="menuitem"
        >
          {item}
        </div>
      )
    }
  };

  return (
    <div
      className={isOpen
        ? classnames(styles.popup, styles.visible, customMenuStyles, {
          [styles.alignToBottom]: menuFalls, [customMenuFallsStyles] : menuFalls
        })
        : styles.hidden
      }
      role="menu"
      ref={menuRef}
    >
      {content.map(mapContent)}
    </div>
  );
};

const ButtonDropdownCommon = ({
                                triggerComponent = null,
                                content,
                                customMenuStyles,
                                customMenuFallsStyles
                              }) => {
  const {buttonProps, itemProps, isOpen} = useDropdownMenu(6);
  const menuProps = {
    isOpen,
    itemProps,
    content,
    customMenuStyles,
    customMenuFallsStyles
  };

  return (
    <div className={styles.buttonDropdown}>
      {triggerComponent
        ? <div {...buttonProps}>{triggerComponent}</div>
        : (
          <div  {...buttonProps} className={styles.button}>
            <img
              src={threeDots}
              alt="open popup"
            />
          </div>
        )
      }
      <Menu {...menuProps}/>
    </div>
  );
};

export default ButtonDropdownCommon;